import { Tag } from 'antd'
import StyledTooltip from 'components/Elements/StyledTooltip'
import { DataContext } from 'contexts/DataContextContainer'
import moment from 'moment'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { BiMoveVertical } from 'react-icons/bi'
import {
  FaCheckCircle,
  FaEllipsisH,
  FaEnvelope,
  FaPlusSquare,
  FaUserFriends,
} from 'react-icons/fa'
import { ROLES } from 'services/constants'
import { useBookRoleQuery } from 'store/queries'
import { QuestionItemContainer } from '../style'

function Question({
  question = {},
  bookDetail,
  addNewStory,
  isAfterCutoff,
  dndListeners = [],
}) {
  const { t } = useTranslation()
  const { setPromptRolesModalConfig } = useContext(DataContext)
  const { data: role } = useBookRoleQuery(bookDetail?.id)

  const rolesToDisplay = JSON.parse(JSON.stringify(ROLES))
  delete rolesToDisplay['purchaser']
  delete rolesToDisplay['guest']
  delete rolesToDisplay['none']

  const isPurchaserOrEditor =
    role?.name === 'Editor' || role?.name === 'Purchaser'
  const isAuthor = role?.name === 'Author'

  const handleSendPromptClick = () => {
    setPromptRolesModalConfig({
      type: 4,
      question,
      show: true,
    })
  }

  const handleEditRolesClick = () => {
    if (isPurchaserOrEditor) {
      if (question.is_sent === 0) {
        setPromptRolesModalConfig({
          type: 2,
          question,
          show: true,
        })
      } else {
        setPromptRolesModalConfig({
          type: 3,
          question,
          show: true,
        })
      }
    } else {
      setPromptRolesModalConfig({
        type: 1,
        question,
        show: true,
      })
    }
  }
  const hasExistingUserAnswer = question?.answers?.find(
    (a) => a.user_id === role?.id,
  )

  const canAddNewStory =
    !hasExistingUserAnswer &&
    (isPurchaserOrEditor || isAuthor) &&
    question.is_sent &&
    !bookDetail.is_published

  return (
    <QuestionItemContainer className="px-3">
      <div className="desktop">
        <h6 className={`question-date ${isAfterCutoff ? 'question-gray' : ''}`}>
          {question.will_send_on_datetime
            ? moment(question.will_send_on_datetime).format('DD/MM/YY')
            : moment(question.sent_datetime).format('DD/MM/YY')}
        </h6>
        <div
          className={`question-icon ${isAfterCutoff ? 'question-gray' : ''}`}
        >
          <StyledTooltip title={t('tt_edit_user_role')} placement="top">
            <FaUserFriends onClick={() => handleEditRolesClick(question)} />
          </StyledTooltip>
        </div>
        <div
          className={`question-icon ${isAfterCutoff ? 'question-gray' : ''}`}
        >
          {question.is_sent ? (
            question.allSubmitted ? (
              <StyledTooltip
                title={t('tt_prompt_status_submitted')}
                placement="top"
              >
                <FaCheckCircle />
              </StyledTooltip>
            ) : (
              <StyledTooltip title={t('tt_prompt_status_sent')} placement="top">
                <FaEllipsisH />
              </StyledTooltip>
            )
          ) : bookDetail.welcome_sent && !bookDetail.is_published ? (
            <StyledTooltip title={t('tt_email_prompt')} placement="top">
              <div className="email-prompt-btn">
                <FaEnvelope onClick={() => handleSendPromptClick(question)} />
              </div>
            </StyledTooltip>
          ) : (
            <></>
          )}
        </div>

        <h6
          className={`question-content ${isAfterCutoff ? 'question-gray' : ''}`}
        >
          {question.dsply_text}
        </h6>
        {typeof question.tags === 'string' &&
          question.tags.split(',').map((_tag, _i) => {
            return (
              <Tag
                key={_i}
                color={`${_tag.split(':')[1] || '#52725D'}`}
                className="ml-2"
              >
                {_tag.split(':')[0]}
              </Tag>
            )
          })}

        {canAddNewStory ? (
          <div className="add-story-wrapper ml-auto">
            <StyledTooltip title={t('tt_add_own_story')} placement="left">
              <FaPlusSquare
                className="add-story"
                onClick={(e) => addNewStory(e, question)}
              />
            </StyledTooltip>
          </div>
        ) : (
          <></>
        )}
        {!canAddNewStory && !question.is_sent && (
          <div className="move-story-wrapper ml-auto" {...dndListeners}>
            <StyledTooltip title={t('tt_drag_and_drop')} placement="left">
              {role?.name === 'Editor' || role?.name === 'Purchaser' ? (
                <BiMoveVertical />
              ) : (
                <></>
              )}
            </StyledTooltip>
          </div>
        )}
      </div>
      <div className="mobile py-2">
        <div className="top">
          <h6 className="question-date">
            {question.will_send_on_datetime
              ? moment(question.will_send_on_datetime).format('DD/MM/YY')
              : moment(question.sent_datetime).format('DD/MM/YY')}
          </h6>
          <div className="question-icon">
            <StyledTooltip title={t('tt_edit_user_role')} placement="top">
              <FaUserFriends onClick={() => handleEditRolesClick(question)} />
            </StyledTooltip>
          </div>
          <div className="question-icon">
            {question.is_sent ? (
              question.allSubmitted ? (
                <StyledTooltip
                  title={t('tt_prompt_status_submitted')}
                  placement="top"
                >
                  <FaCheckCircle />
                </StyledTooltip>
              ) : (
                <StyledTooltip
                  title={t('tt_prompt_status_sent')}
                  placement="top"
                >
                  <FaEllipsisH />
                </StyledTooltip>
              )
            ) : bookDetail.welcome_sent && !bookDetail.is_published ? (
              <StyledTooltip title={t('tt_email_prompt')} placement="top">
                <FaEnvelope
                  onClick={() => handleSendPromptClick(question)}
                  data-testid="email-prompt-button"
                />
              </StyledTooltip>
            ) : (
              <></>
            )}
          </div>
          {canAddNewStory ? (
            <div className="add-story-wrapper ml-auto">
              <StyledTooltip title={t('tt_add_own_story')} placement="left">
                <FaPlusSquare
                  className="add-story"
                  onClick={(e) => addNewStory(e, question)}
                />
              </StyledTooltip>
            </div>
          ) : (
            <div className="move-story-wrapper ml-auto" {...dndListeners}>
              <StyledTooltip title={t('tt_drag_and_drop')} placement="left">
                {role?.name === 'Editor' || role?.name === 'Purchaser' ? (
                  <BiMoveVertical />
                ) : (
                  <></>
                )}
              </StyledTooltip>
            </div>
          )}
        </div>
        <div className="bottom">
          <h6 className="question-content">{question.dsply_text}</h6>
        </div>
      </div>
    </QuestionItemContainer>
  )
}

export default Question
